/**
 * Asynchronously loads the component for RentalWidgetContainer
 */
import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./RentalWidgetContainer'),
  loading: () => null,
});
